import { Stack } from "@mui/material";

const DashboardComponent = () => {
 return (
  <Stack>
   <iframe
    title="CommsBuilder Learning Dashboard"
    width="100%"
    height="541.25"
    src="
https://app.powerbi.com/reportEmbed?reportId=32e4427a-3bee-402f-a758-4601ef78845b&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
    frameborder="0"
    allowFullScreen="true"
   ></iframe>
  </Stack>
 );
};

export default DashboardComponent;
